import React from 'react';

import { TimeCounter } from '../../../components/TimeCounter/TimeCounter';

import { MObywatelRequest } from './types';

interface TimeCountersProps {
  request: MObywatelRequest;
}

export const TimeCounters: React.FC<TimeCountersProps> = ({ request }) => {
  // Don't show any timers for completed or rejected verifications
  if (['completed', 'rejected'].includes(request.status)) {
    return null;
  }

  const elements = [];

  // Instructions shown counter - only relevant if still in instructions or waiting phases
  if (request.instructionsShownAt && ['instructions_shown', 'waiting_for_code'].includes(request.status)) {
    elements.push(
      <TimeCounter
        key="instructions"
        startTime={request.instructionsShownAt.toDate()}
        prefix="📋"
        suffix="od instrukcji"
        className="text-xs"
      />
    );
  }

  // Code requested counter - only relevant while waiting for code or code expired
  if (request.codeRequestedAt && ['waiting_for_code', 'code_expired'].includes(request.status)) {
    elements.push(
      <TimeCounter
        key="code-requested"
        startTime={request.codeRequestedAt.toDate()}
        prefix="⏱️"
        suffix="od żądania"
        className="mr-2 mb-1"
        warningThresholds={{
          yellow: 120, // 2 minutes
          red: 180, // 3 minutes
        }}
      />
    );
  }

  // Code provided counter - only relevant when code is active
  if (request.codeProvidedAt && request.status === 'code_provided') {
    elements.push(
      <TimeCounter
        key="code-provided"
        startTime={request.codeProvidedAt.toDate()}
        countdownDuration={180}
        prefix="💫"
        suffix="do wygaśnięcia"
        className="mr-2 mb-1"
        warningThresholds={{
          yellow: 120, // 2 minutes
          red: 60, // 1 minute
        }}
      />
    );
  }

  // Modal shown counter - only relevant when awaiting user response
  if (request.modalShownAt && request.status === 'awaiting_user_response') {
    elements.push(
      <TimeCounter
        key="modal-shown"
        startTime={request.modalShownAt.toDate()}
        prefix="⏰"
        suffix="od pokazania modala"
        className="mr-2 mb-1"
        warningThresholds={{
          yellow: 180, // 3 minutes
          red: 240, // 4 minutes
        }}
      />
    );
  }

  // User response deadline countdown - only relevant when awaiting user response
  if (request.userResponseDeadline && request.status === 'awaiting_user_response') {
    elements.push(
      <TimeCounter
        key="response-deadline"
        startTime={new Date()}
        countdownDuration={Math.max(
          0,
          Math.floor((request.userResponseDeadline.toDate().getTime() - Date.now()) / 1000)
        )}
        prefix="⏳"
        suffix="do deadline"
        className="mr-2 mb-1"
        warningThresholds={{
          yellow: 120, // 2 minutes left
          red: 60, // 1 minute left
        }}
      />
    );
  }

  return elements.length > 0 ? <div className="flex flex-wrap gap-1">{elements}</div> : null;
};
